import { GET_MATCHED_JOBS,SEARCH_APPLY_JOBS_API } from "../../../utils/routes"; 
import getDispatch from "../common/getDispatch"
import setErrorMessage from "../common/setErrorMessage"
import {GET_MATCHED_JOBS_TYPE,SEARCH_APPLY_JOBS} from "../types"
import axios from 'axios'

export const viewMatchedJobs = (data) => (dispatch) =>{
axios
  .post(GET_MATCHED_JOBS,data,{withCredentials:true})
  .then((res)=>{
  dispatch(getDispatch(GET_MATCHED_JOBS_TYPE,res))

 }) .catch((err)=>{
dispatch(setErrorMessage(err))
})
}

export const searchMatchedJobs = (data) => (dispatch) =>{
  axios
    .post(SEARCH_APPLY_JOBS_API,data,{withCredentials:true})
    .then((res)=>{
    if(!res.data.length){
    dispatch({
      type:"EMPTY_ARRAY",
      payload:"Data not found"
    })
  setTimeout(()=>{
      dispatch({
        type:"EMPTY_ARRAY",
        payload:""
      })
    },3000)
    }
    else{
      dispatch(getDispatch(SEARCH_APPLY_JOBS,res))
    }
   
  
   }) .catch((err)=>{
  dispatch(setErrorMessage(err))
  })
  }